<template>
  <div class="warper clearfix categoriesBox">
    <div class="h1box">
      <h1>产品文档</h1>
    </div>
    <div class="jisuBox-header pointer" @click="goJiSu">
      <span style="margin-right:0.5rem">极速智能配置</span
      ><svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.246094 6.25C0.246094 5.69771 0.693809 5.25 1.24609 5.25H7.83188L5.03899 2.45711C4.64846 2.06658 4.64846 1.43342 5.03899 1.04289C5.42951 0.652369 6.06268 0.652369 6.4532 1.04289L10.9525 5.54218C10.9554 5.54511 10.9583 5.54805 10.9612 5.55101C11.0531 5.64499 11.1228 5.75259 11.1702 5.86722C11.2186 5.98378 11.2455 6.11147 11.2461 6.24538L11.2461 6.25L11.2461 6.25422C11.2449 6.52687 11.1345 6.77415 10.9565 6.95383L10.9527 6.95761L6.4532 11.4571C6.06268 11.8476 5.42951 11.8476 5.03899 11.4571C4.64846 11.0666 4.64846 10.4334 5.03899 10.0429L7.83188 7.25H1.24609C1.21158 7.25 1.17747 7.24825 1.14385 7.24484C0.639593 7.19363 0.246094 6.76777 0.246094 6.25Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="jisuBox">
      <a-row type="flex" justify="space-around" align="top">
        <a-col
          :span="index == 1 ? 8 : index == 3 ? 4 : 6"
          v-for="(item, index) in JiSu_List"
          :key="'JiSu' + item.id"
          class="cate-box"
        >
          <div class="cate-name1">
            <i v-if="index == 0" class="iconfont icon-menu-overview"></i>
            <i v-if="index == 1" class="iconfont icon-menu-project"></i>
            <i v-if="index == 2" class="iconfont icon-other-tuning"></i>
            <i v-if="index == 3" class="iconfont icon-prof-projects"></i>
            <span>{{ item.name }}</span>
          </div>
          <div class="cate-info1">
            <ul v-if="index != 1">
              <li
                v-for="child in item.children"
                style="list-style-type: disc; list-style-position: inside"
                @click="goUrl(child)"
              >
                <span
                  class="disable CatePointer"
                  v-if="child.flag == 'disable'"
                >
                  {{ child.name }}
                </span>
                <span class="CatePointer PointerHover" v-else>
                  {{ child.name }}
                </span>
              </li>
            </ul>
            <ul v-else>
              <a-row type="flex">
                <a-col
                  ><li
                    v-for="(child, childIndex) in item.children"
                    :key="childIndex"
                    v-if="childIndex <= 5"
                    style="list-style-type: disc; list-style-position: inside"
                    @click="goUrl(child)"
                  >
                    <span
                      class="disable CatePointer"
                      v-if="child.flag == 'disable'"
                    >
                      {{ child.name }}
                    </span>
                    <span v-else class="CatePointer PointerHover">
                      {{ child.name }}
                    </span>
                  </li></a-col
                >
                <a-col
                  ><li
                    v-for="(child, childIndex) in item.children"
                    :key="childIndex"
                    v-if="childIndex > 5"
                    style="list-style-type: disc; list-style-position: inside"
                    @click="goUrl(child)"
                  >
                    <span
                      class="disable CatePointer"
                      v-if="child.flag == 'disable'"
                    >
                      {{ child.name }}
                    </span>
                    <span v-else class="CatePointer PointerHover">
                      {{ child.name }}
                    </span>
                  </li></a-col
                >
              </a-row>
            </ul>
          </div>
          <div v-if="index != 3" class="cate-arrow">
            <img src="../assets/icon/cate/cate-arrow.png" />
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="otherBox">
      <a-row type="flex" justify="space-around" align="top">
        <div
          v-for="(first, index) in List"
          :key="'first' + index"
          style=""
        >
          <div class="cate-name2">{{ first.name }}</div>
          <div
            v-for="(second, index) in first.children"
            :key="'second' + index"
            @click="goUrl(second)"
          >
            <p class="disable CatePointer" v-if="second.flag == 'disable'">
              {{ second.name }}
            </p>
            <p class="CatePointer PointerHover" v-else>
              {{ second.name }}
              <!-- <i v-if="second.flag == 'HOT' || second.flag == 'hot'" class="iconfont icon-hot" color="#DE321F"></i> -->
            </p>
          </div>
        </div>
      </a-row>
    </div>
  </div>
</template>
<script>
import { categories } from "@/utils/query.js";

export default {
  data() {
    return {
      JiSu_List: [],
      List: [],
    };
  },
  created() {
    this.getCate();
  },
  methods: {
    async getCate() {
      let res = await categories();
      this.List = [];
      if (res.success) {
        this.JiSu_List = res.data.directoryJson[0].children;
        this.List = res.data.directoryJson.filter((element, index, self) => {
          return index > 0;
        });
      }

    },
    goJiSu() {
      this.$router.push({
        name: "JiSu",
      });
      this.sentzhugePoint("极速智能配置说明页面");
    },
    // bz位代表是否是极速智能配置
    goUrl(item) {
      let id = item.id;
      if (item.children.length >= 1) {
        id = item.children[0].id;
      }
      this.$router.push({
        name: "ArticleList",
        query: { id },
      });
    },
    sentzhugePoint(lv01 = "") {
      this.zhugePoint("macc-help-文档中心-模块统计", {
        userid: this.GLOBAL.userid, //用户id
        lv01, //一级目录、模块
      });
    },
  },
};
</script>
<style scoped>
.categoriesBox {
  min-height: 42vh;
}
.h1box {
  text-align: center;
  padding: 2rem;
  padding-bottom: 1.5rem;
}
.h1box h1 {
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  padding-bottom: 8px;
  position: relative;
  display: inline-block;
}
.h1box h1::after {
  content: "";
  background: #2b6afd;
  border-radius: 9px;
  height: 0.5rem;
  width: 3rem;
  position: absolute;
  top: 100%;
  right: 1.5rem;
}

.jisuBox-header {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  /* height: 6rem; */
  height: 96px;
  width: 293px;
  text-align: center;
  background: url("../assets/icon/js_bg.png") center no-repeat;
  border-radius: 0.5rem 2rem 0.5rem 0.5rem;
  backdrop-filter: blur(20px);
  padding-top: 12px;
}
.jisuBox-header span {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #fff;
}
.jisuBox {
  margin-top: 50px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #eaf1ff;
  box-shadow: 2px 6px 15px rgba(236, 238, 243, 0.8);
  backdrop-filter: blur(40px);
  padding: 25px 0;
  height: 330px;
}
.cate-box {
  /* border: #2b6afd 1px solid; */
  position: relative;
  padding: 0 2rem;
  height: 230px;
}
.cate-name1 {
  margin-bottom: 10px;
}
.cate-name1 span {
  display: inline-block;
  color: rgba(0, 0, 0, 0.9);
  font-weight: 600;
  font-size: 18px;
  vertical-align: middle;
  line-height: 26px;
}
.cate-name1 .iconfont {
  vertical-align: middle;
  margin-right: 0.7rem;
  color: #2b6afd;
  font-size: 26px;
  line-height: 26px;
}

.cate-info1 {
  font-size: 14px;
  line-height: 35px;
  color: rgba(0, 0, 0, 0.65);
}
.cate-info1 ul li {
  padding-left: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cate-arrow {
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 1rem;
}
.otherBox {
  padding-top: 3rem;
  padding-bottom: 5rem;
}
.cate-name2 {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.9);
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #eaf1ff;
}
.cate-info2 {
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
.CatePointer {
  cursor: pointer;
}
.PointerHover:hover {
  color: #2b6afd;
}
.disable {
  color: rgba(0, 0, 0, 0.25);
}
</style>
